// ViewBannerModal.tsx

import React, { useEffect, useState } from "react";
import { Modal, Text, Button, Group, TextInput, Stack } from "@mantine/core";
import { IconPhoto } from "@tabler/icons-react";
import classes from "./view.module.css"; // Use appropriate styles
import { RowDataTerms } from "./types";

interface ViewTermsModalProps {
  isOpen: boolean;
  onClose: () => void;
  termsData: RowDataTerms;
}

const ViewTermsModal: React.FC<ViewTermsModalProps> = ({
  isOpen,
  onClose,
  termsData,
}) => {

    const [terms, setTerms] = useState<string[]>([])

    useEffect(() => {
        setTerms(termsData?.content ? JSON.parse(termsData?.content) : [])
      }, [termsData]);

  return (
    <Modal
      title={
        <div style={{ textAlign: "center", fontWeight: "bold" }}>
          View Terms & Conditions
        </div>
      }
      opened={isOpen}
      onClose={onClose}
    >

      <TextInput label="Title:" mb="sm" value={termsData.title} readOnly />

      <Stack gap={8} mb="sm">
        {terms.length > 0 ? <Text className={classes.Text}>Terms & Conditions</Text> : null}
        {terms.map((item, i)=>(
            <Text c={'#202020'} fw={'700'} fz={14}>{i+1}. <span style={{fontWeight: '400'}}>{item}</span></Text>
        ))
        }
        </Stack>

      {/* <Group className={classes.buttonBottom}>
        <Button onClick={onClose} className={classes.buttonClose}>
          Close
        </Button>
      </Group> */}
    </Modal>
  );
};

export default ViewTermsModal;
